import { THEME_DICTIONARY_LOADERS } from './loaders.gen.js';
import { applyTexts } from './paths.js';
/** The dictionary for (theme, locale), or undefined when none ships. */
export async function loadThemeDictionary(themeId, locale) {
    const load = THEME_DICTIONARY_LOADERS[themeId]?.[locale];
    if (!load)
        return undefined;
    return (await load()).default;
}
/** The languages a theme ships a dictionary for. */
export function themeDictionaryLocales(themeId) {
    return Object.keys(THEME_DICTIONARY_LOADERS[themeId] ?? {});
}
/**
 * A COPY of `doc` with every dictionary sentence written in — sections and blocks keep their ids, so
 * the theme-seed signature the builder stamps afterwards fingerprints the localized text.
 */
export async function localizeThemeDocument(themeId, doc, locale) {
    const dictionary = await loadThemeDictionary(themeId, locale);
    if (!dictionary)
        return doc;
    const copy = structuredClone(doc);
    applyTexts(copy, dictionary.entries);
    return copy;
}
//# sourceMappingURL=localize.js.map